import React from "react";
import { Link } from "react-router-dom";
import { Clock, ShieldCheck, Gem, Sparkles, ArrowRight } from "lucide-react";
import { useLang } from "../i18n";
import { PageHero } from "../components/PageHero";
import { Reveal, RevealImage } from "../components/Reveal";
import { IMAGES } from "../lib/data";

export default function About() {
  const { t } = useLang();
  const values = [
    { icon: Clock, t: "about.v1t", d: "about.v1d" },
    { icon: ShieldCheck, t: "about.v2t", d: "about.v2d" },
    { icon: Gem, t: "about.v3t", d: "about.v3d" },
    { icon: Sparkles, t: "about.v4t", d: "about.v4d" },
  ];
  return (
    <>
      <PageHero tag={t("about.tag")} title={t("about.title")} image={IMAGES.interior} />

      <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
        <div className="grid gap-16 lg:grid-cols-2 lg:gap-20">
          <RevealImage src={IMAGES.chauffeur} alt="Chauffeur" className="h-[420px] lg:h-[560px]" />
          <div className="flex flex-col justify-center">
            <Reveal><p className="font-body text-base leading-relaxed text-white/70">{t("about.p1")}</p></Reveal>
            <Reveal delay={0.1}><p className="mt-6 font-body text-base leading-relaxed text-white/60">{t("about.p2")}</p></Reveal>
            <Reveal delay={0.2}>
              <Link to="/booking" data-testid="about-cta"
                className="mt-10 inline-flex w-fit items-center gap-2 bg-gold px-8 py-4 font-body text-xs uppercase tracking-[0.2em] text-black transition-colors hover:bg-gold-muted">
                {t("common.bookNow")} <ArrowRight size={16} />
              </Link>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="border-t border-white/5 bg-matte-deep py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal><h2 className="font-heading text-4xl font-medium text-white lg:text-5xl">{t("about.values")}</h2></Reveal>
          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v, i) => (
              <Reveal key={v.t} delay={i * 0.08} className="border border-white/10 bg-matte-surface p-8">
                <v.icon size={28} className="text-gold" strokeWidth={1.4} />
                <h3 className="mt-6 font-display text-xl text-white">{t(v.t)}</h3>
                <p className="mt-3 font-body text-sm leading-relaxed text-white/50">{t(v.d)}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
